import createReducer from '../utils/createReducer';
import ListingAvailabilityActions from '../actions/listingAvailabilityActions';

const initialState = {
    dateless: null,
    checkin: null,
    checkout: null
};

const actionHandlers = {
    [ListingAvailabilityActions.UPDATE_AVAILABILITY](state, {payload}) {
        const {availabilityData} = payload;
        return {
            ...state,
            ...availabilityData
        };
    }
};

export default createReducer(actionHandlers, initialState);
